import DealerUserTableRow from '../../dealer-users/components/DealerUserTableRow';
import PropTypes from 'prop-types';
import React from 'react';
import { BottomScrollListener } from '@ami/react/core';

const DealerUserTable = ({
  dealerUsers,
  onOpenEdit,
  loading,
  onBottomScroll,
}) => {
  const rows = dealerUsers.map((dealerUser) => (
    <DealerUserTableRow
      dealerUser={dealerUser}
      key={dealerUser.userId}
      onOpenEdit={onOpenEdit}
    />
  ));
  return (
    <div className="recent-list-wrapper">
      <ul className="list-unstyled">
        <BottomScrollListener onBottom={onBottomScroll}>
          <>
            {rows}
            {(loading || rows.length === 0) && <hr />}
            {loading && (
              <span>
                Loading... <i className="fa fa-spin fa-spinner" />
              </span>
            )}
            {!loading && rows.length === 0 && <span>No data found</span>}
          </>
        </BottomScrollListener>
      </ul>
    </div>
  );
};

DealerUserTable.propTypes = {
  dealerUsers: PropTypes.array.isRequired,
  onOpenEdit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onBottomScroll: PropTypes.func.isRequired,
};

export default DealerUserTable;
